export { default as Img200 } from './processed/200/threehundred.jpg';
export { default as Img400 } from './processed/400/threehundred.jpg';
export { default as Imgthumb } from './processed/thumb/threehundred.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/threehundred.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/threehundred.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      167,
      29,
      35
    ],
    "_population": 144,
    "_hsl": [
      0.9927536231884058,
      0.7040816326530611,
      0.3843137254901961
    ]
  },
  "LightVibrant": {
    "_rgb": [
      220,
      195,
      169
    ],
    "_population": 69,
    "_hsl": [
      0.08496732026143784,
      0.4214876033057853,
      0.7627450980392156
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      122,
      17,
      23
    ],
    "_population": 1216,
    "_hsl": [
      0.9904761904761905,
      0.7553956834532374,
      0.27254901960784317
    ]
  },
  "Muted": {
    "_rgb": [
      168,
      116,
      84
    ],
    "_population": 10,
    "_hsl": [
      0.06349206349206349,
      0.3333333333333333,
      0.49411764705882355
    ]
  },
  "LightMuted": {
    "_rgb": [
      204,
      191,
      176
    ],
    "_population": 581,
    "_hsl": [
      0.08928571428571426,
      0.2153846153846155,
      0.7450980392156863
    ]
  },
  "DarkMuted": {
    "_rgb": [
      76,
      46,
      43
    ],
    "_population": 2954,
    "_hsl": [
      0.015151515151515136,
      0.27731092436974786,
      0.23333333333333334
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/threehundred.js